import { Injectable } from "@angular/core";

@Injectable()
export class RoundingFormatterService {
  constructor() {}

  transform(value: number | string, fractionSize: number = 2) {
    let formattedValue: string = value != null ? value.toString() : "";

    if (formattedValue) {
      let floatValue = parseFloat(formattedValue);
      // let roundingValue = Math.pow(10, fractionSize);
      // return Math.round(floatValue * roundingValue) / roundingValue;
      return floatValue.toFixed(fractionSize);
    }
    return;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/models/rounding-formatter.service.ts